module.exports = __webpack_public_path__ + "static/media/banner2b.f7184f1d.svg";